<template>
<div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  <v-data-table
    :headers="headers"
    :items="module_super_master_list"
    class="elevation-1"
     :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Module</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Module</v-btn>
          </template>
          <v-card>
            <v-form v-model="valid">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field 
                      v-model="editedItem.module_super_master"
                      item-text="gender_super_master_list"
                      item-value="id"
                      persistent-hint
                      
                      :hint="editedIndex==-1?'For example :: Accounts, Admission':'For example :: Accounts, Admission'"
                      label="Enter Module Name"
                      :error="errorMsg.module_super_master?true:false"
                      :error-messages="errorMsg.module_super_master?'Required':''"
                      :rules="[v => !!v || 'required']"
                    ></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.link" 
                    persistent-hint
                    :hint="editedIndex==-1?'For example :: /role-manage, /admission':'For example ::  /role-manage, /admission'"
                    label="Enter Link Name"
                    :rules="[v => !!v || 'required']">
                    </v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                    <v-checkbox
                        dense
                        v-model="editedItem.isactive"
                        color="success"
                        label="Active"
                      ></v-checkbox>
                  </v-col>     
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="primary darken-1"  @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

         <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon  class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon  class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>

    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="25" class="edit-avatar">
          <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
       </v-avatar>
      </div>
      <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
    </template>
    <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
  </v-data-table>
  <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</div>
</template>

<script>
import axios from 'axios'
  export default {
    data: () => ({
      valid: false,
      overlay: false,
      errorMsg:{
        module_super_master:false
      },
      snackbar: false,
      search:'',
      dialog: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Module Name',align: 'left',sortable: false,value: 'module_super_master',
        },
        { text: 'Link', sortable: false, value: 'link' },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      module_super_master_list: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        module_super_master: '',
        link: '',
        icon:'',
        isactive:true  
      },
      defaultItem: {
        id: '',
        module_super_master: '',
         link: '',
         icon:'',
        isactive:true      
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Module' : 'Edit Module'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
           overlay (val) {
        val(() => {
          this.overlay = false
        },)
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
       this.onLoad()
     },
    methods: {
    //   initialize () {
        
    //   },
      onLoad(){
        this.overlay=true;
      axios
      .post("/admin/adminModule")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
          
          if(this.load = true){
            this.overlay=false;
            this.module_super_master_list = res.data.module_super_master_list
          }
        } else {
          window.console.log(res.data.msg)
        }
      })
       .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        overlay=false;
      });
      },
      editItem (item) {
        this.editedIndex = this.module_super_master_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
       showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
      // deleteItem (item) {
      //   const index = this.module_super_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.module_super_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/Admin/editAdminModule", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.msg)
              Object.assign(this.module_super_master_list[this.editedIndex], this.editedItem);
              this.showSnackbar(
                  "#4caf50",
                  "Module Updated Successfully..."
                ); // show snackbar on success
            }
            else if(res.data.status.code == "NA"){
              this.showSnackbar("#b71c1c", "Module Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
          if(this.isValidated())
         {
           axios
          .post("/Admin/saveAdminModule", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
            //window.alert(res.data.status.code)
            this.module_super_master_list.push(this.editedItem)
             this.showSnackbar("#4caf50", "Module Added Successfully!!!"); // show snackbar on success
             this.onLoad()      
            }
            else if(res.data.status.code == "NA"){
                //window.alert(res.data.status.code)
                 this.showSnackbar("#b71c1c", "Module Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
         }
        }
      }, //save()
      isValidated(){
      if(this.editedItem.module_super_master)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.module_super_master)
            {
              this.errorMsg.module_super_master=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>